// The Pricing Calculator guide (29_PricingCalculator.jsx · ModuleHelp, Max 01/11).
const en = {
  modesT: 'Pick what you are doing',
  modesB: 'General Collab prices an OEM / ODM quote. The Licensed tab (not shown to the CEO) is the royalty model, Saved projects lists quotes already saved, and Pricing rules appears only for admins.',
  nameT: 'Name the quote',
  nameB: 'Give the quote a name and, if you like, a folder such as a season, so related quotes sit together. The quote ID appears after the first save.',
  actionsT: 'Save, export, import',
  actionsB: 'Save keeps the quote. Export Excel and the two imports (a Price Approval workbook, or a vendor BOM) are for whoever builds the quote, so what you see depends on your role.',
  skuT: 'One tab per SKU',
  skuB: 'A quote can price several SKUs. Click a tab to work on that SKU, and use the buttons beside the tabs to add, duplicate or delete one.',
  inputsT: 'The inputs, step by step',
  inputsB: 'Numbered blocks in the order a quote is built: the order, the factory cost, the frame, other costs, profit and the target. Use the fold button to collapse this panel.',
  resultT: 'The result',
  resultB: 'Shows the cost build-up and the price taken on it: the tiers, what the order earns, the MSRP and the options. It recalculates as you change the inputs.',
};
const ko = {
  modesT: '작업 선택',
  modesB: '일반 콜라보는 OEM / ODM 견적의 가격을 산정합니다. 라이선스 탭(CEO에게는 보이지 않음)은 로열티 모델, 저장된 프로젝트는 저장한 견적 목록이며, 가격 규칙은 관리자에게만 나타납니다.',
  nameT: '견적 이름 정하기',
  nameB: '견적 이름과, 필요하면 시즌 같은 폴더를 지정해 관련 견적을 한곳에 모으세요. 견적 ID는 처음 저장한 뒤에 나타납니다.',
  actionsT: '저장, 내보내기, 가져오기',
  actionsB: '저장하면 견적이 보관됩니다. Excel 내보내기와 두 가지 가져오기(Price Approval 워크북 또는 벤더 BOM)는 견적을 작성하는 사람용이라, 역할에 따라 보이는 버튼이 다릅니다.',
  skuT: 'SKU마다 탭 하나',
  skuB: '한 견적에서 여러 SKU의 가격을 산정할 수 있습니다. 탭을 눌러 해당 SKU를 작업하고, 탭 옆 버튼으로 SKU를 추가·복제·삭제하세요.',
  inputsT: '입력값, 단계별',
  inputsB: '견적을 만드는 순서대로 번호가 붙은 블록입니다. 주문, 공장 원가, 프레임, 기타 비용, 이익, 목표 순입니다. 접기 버튼으로 이 패널을 접을 수 있습니다.',
  resultT: '결과',
  resultB: '원가 구성과 그 위에 붙는 가격을 보여 줍니다. 티어, 주문 수익, MSRP, 옵션이 포함되며 입력값을 바꾸면 바로 다시 계산됩니다.',
};
const vi = {
  modesT: 'Chọn việc bạn đang làm',
  modesB: 'General Collab tính giá báo giá OEM / ODM. Tab Licensed (CEO không thấy) là mô hình royalty, Saved projects liệt kê các báo giá đã lưu, còn Pricing rules chỉ hiện với admin.',
  nameT: 'Đặt tên báo giá',
  nameB: 'Đặt tên cho báo giá và, nếu muốn, chọn một thư mục như season để các báo giá liên quan nằm cùng nhau. Mã báo giá xuất hiện sau lần lưu đầu tiên.',
  actionsT: 'Lưu, xuất, nhập',
  actionsB: 'Lưu để giữ lại báo giá. Xuất Excel và hai cách nhập (file Price Approval hoặc BOM của vendor) dành cho người lập báo giá, nên nút bạn thấy tùy theo vai trò.',
  skuT: 'Mỗi SKU một tab',
  skuB: 'Một báo giá có thể tính giá nhiều SKU. Bấm vào tab để làm việc với SKU đó, và dùng các nút cạnh tab để thêm, nhân bản hoặc xóa SKU.',
  inputsT: 'Các thông số đầu vào, từng bước',
  inputsB: 'Các khối đánh số theo thứ tự lập báo giá: đơn hàng, giá xưởng, khung (frame), chi phí khác, lợi nhuận và mục tiêu. Nút thu gọn giúp gập panel này lại.',
  resultT: 'Kết quả',
  resultB: 'Hiện phần cấu thành giá vốn và mức giá cộng lên trên đó: các tier, lợi nhuận của đơn, MSRP và các phương án. Kết quả tự tính lại khi bạn đổi thông số.',
};
const zh = {
  modesT: '选择要做的事',
  modesB: 'General Collab 用于核算 OEM / ODM 报价。Licensed 标签页（CEO 看不到）是版税模型，Saved projects 列出已保存的报价，Pricing rules 只对管理员显示。',
  nameT: '给报价命名',
  nameB: '为报价起个名字，也可以指定一个文件夹（例如季度），让相关报价放在一起。报价编号在第一次保存后出现。',
  actionsT: '保存、导出、导入',
  actionsB: '保存会留存报价。导出 Excel 和两种导入（Price Approval 工作簿或供应商 BOM）是给制作报价的人用的，所以您看到的按钮取决于角色。',
  skuT: '每个 SKU 一个标签页',
  skuB: '一份报价可以核算多个 SKU。点击标签页处理对应的 SKU，用标签页旁的按钮添加、复制或删除 SKU。',
  inputsT: '输入项，逐步填写',
  inputsB: '按制作报价的顺序编号的区块：订单、工厂成本、框架（frame）、其他费用、利润和目标。可用折叠按钮收起此面板。',
  resultT: '结果',
  resultB: '显示成本构成以及在其上加成的价格：各档价格、订单收益、MSRP 和各个方案。修改输入项后会自动重新计算。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "modesT": "Choisir ce que vous faites",
  "modesB": "Collab générale chiffre un devis OEM / ODM. L'onglet Collab sous licence (redevance), non affiché au CEO, est le modèle de redevances, Projets enregistrés liste les devis déjà enregistrés, et Règles de tarification n'apparaît que pour les admins.",
  "nameT": "Nommer le devis",
  "nameB": "Donnez un nom au devis et, si vous le souhaitez, un dossier comme une saison, pour que les devis liés restent ensemble. L'ID du devis apparaît après le premier enregistrement.",
  "actionsT": "Enregistrer, exporter, importer",
  "actionsB": "Enregistrer conserve le devis. Exporter Excel et les deux imports (un classeur Price Approval ou un BOM fournisseur) sont destinés à celui qui construit le devis ; ce que vous voyez dépend donc de votre rôle.",
  "skuT": "Un onglet par SKU",
  "skuB": "Un devis peut chiffrer plusieurs SKU. Cliquez sur un onglet pour travailler sur ce SKU, et utilisez les boutons à côté des onglets pour en ajouter, dupliquer ou supprimer un.",
  "inputsT": "Les données, étape par étape",
  "inputsB": "Des blocs numérotés dans l'ordre de construction d'un devis : la commande, le coût d'usine, le cadre, les autres coûts, le profit et la cible. Utilisez le bouton de repli pour réduire ce panneau.",
  "resultT": "Le résultat",
  "resultB": "Affiche la construction du coût et le prix qui en découle : les paliers, ce que rapporte la commande, le MSRP et les options. Il se recalcule à chaque modification des données."
};
const ja = {
  "modesT": "作業内容を選択",
  "modesB": "「一般 Collab」は OEM / ODM の見積を計算します。「ライセンス Collab（ロイヤリティ）」タブ（CEO には表示されません）はロイヤリティモデル、「保存済みプロジェクト」は保存済みの見積の一覧、「価格設定ルール」は管理者のみに表示されます。",
  "nameT": "見積に名前を付ける",
  "nameB": "見積に名前を付け、必要であればシーズンなどのフォルダーも指定して、関連する見積をまとめます。見積 ID は最初の保存後に表示されます。",
  "actionsT": "保存、エクスポート、インポート",
  "actionsB": "「保存」で見積を保管します。「Excel をエクスポート」と2種類のインポート（Price Approval ブックまたは仕入先 BOM）は見積を作成する担当者向けのため、表示内容はロールによって異なります。",
  "skuT": "SKU ごとに1タブ",
  "skuB": "1つの見積で複数の SKU を計算できます。タブをクリックしてその SKU の作業を行い、タブ横のボタンで SKU の追加、複製、削除ができます。",
  "inputsT": "入力項目を順に",
  "inputsB": "見積を作成する順に番号付きのブロックが並びます。注文、工場コスト、フレーム、その他のコスト、利益、目標です。折りたたみボタンでこのパネルを閉じられます。",
  "resultT": "結果",
  "resultB": "コストの積み上げと、それに基づく価格（ティア、注文の利益、MSRP、オプション）を表示します。入力を変更すると再計算されます。"
};

const dictionary = { ns: 'tourPricingCalc', en, ko, vi, zh, fr, ja };
export default dictionary;
